__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/0316295308e941433e39c219ca9fbd4434a071aed326ad74cc041b3f/";